import OpticksSvgElement from "@/components/ui/OpticksSvgElement/OpticksSvgElement";
import type { OpticksSvgElementProps } from "@/components/ui/OpticksSvgElement/OpticksSvgElement.types";

const OpticksPillPlanLite = ({
  className,
  size,
  width,
  height,
  viewBox = "0 0 51 22",
  "aria-label": ariaLabel,
}: OpticksSvgElementProps) => (
  <OpticksSvgElement
    className={`plan-pill plan-pill-lite${className ? ` ${className}` : ""}`}
    size={size}
    width={width}
    height={height}
    viewBox={viewBox}
    aria-label={ariaLabel}
  >
    <rect
      width="51"
      height="22"
      rx="11"
      fill="var(--color-plan-lite)"
      id="opticks-pill-fill"
    />
    <path
      d="M11.0011 15.5V5.7H13.0311V13.708H18.3931V15.5H11.0011ZM19.7922 15.5V5.7H21.8222V15.5H19.7922ZM26.2806 15.5V7.492H22.9766V5.7H31.6006V7.492H28.3106V15.5H26.2806ZM32.7394 15.5V5.7H40.2714V7.464H34.7694V9.704H38.3954V11.412H34.7694V13.736H40.3274V15.5H32.7394Z"
      fill="white"
      id="opticks-pill-fill"
    />
  </OpticksSvgElement>
);

export default OpticksPillPlanLite;
